(function () {
  'use strict';

  var nav = document.querySelector('[data-rw-mobile-bottom-nav]');
  if (!nav || nav.dataset.initialized === 'true') return;
  nav.dataset.initialized = 'true';
  document.body.classList.add('rw-mobile-bottom-nav-enabled');

  var html = document.documentElement;
  var cartButton = nav.querySelector('[data-rw-mobile-nav-cart]');
  var cartItem = nav.querySelector('[data-rw-mobile-nav-cart-item]');
  var cartBadge = nav.querySelector('[data-cart-count]');

  function readCartCount(detail) {
    if (detail) {
      if (typeof detail.item_count !== 'undefined') return Number(detail.item_count) || 0;
      if (detail.cart && typeof detail.cart.item_count !== 'undefined') return Number(detail.cart.item_count) || 0;
      if (detail.response && typeof detail.response.item_count !== 'undefined') return Number(detail.response.item_count) || 0;
    }

    if (typeof window.rwCurrentCartCount === 'number' && !Number.isNaN(window.rwCurrentCartCount)) {
      return window.rwCurrentCartCount;
    }

    var cartData = document.querySelector('#js_cart_popup #json-data-cart');
    if (cartData) {
      try {
        var cart = JSON.parse(cartData.textContent || '{}');
        if (typeof cart.item_count !== 'undefined') return Number(cart.item_count) || 0;
      } catch (error) {}
    }

    var source = document.querySelector('[data-cart-count]:not(.rw-mobile-bottom-nav__badge), [data-js-cart-count]:not(.rw-mobile-bottom-nav__badge)');
    if (!source) return null;
    var sourceValue = source.getAttribute('data-counter-value') || source.getAttribute('data-js-cart-count') || source.textContent;
    var parsed = parseInt(String(sourceValue || '').replace(/[^0-9]/g, ''), 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function updateCartBadge(count) {
    if (!cartBadge || count === null) return;
    var safeCount = Math.max(Number(count) || 0, 0);
    cartBadge.textContent = safeCount > 99 ? '99+' : String(safeCount);
    cartBadge.setAttribute('data-counter-value', String(safeCount));
    cartBadge.setAttribute('data-js-cart-count', String(safeCount));
    cartBadge.hidden = safeCount === 0;
    cartBadge.classList.toggle('is-zero', safeCount === 0);
    cartBadge.setAttribute('aria-hidden', safeCount === 0 ? 'true' : 'false');
  }

  function syncActionStates() {
    var cartDrawer = document.getElementById('js_cart_popup');
    var cartOpen = Boolean(cartDrawer && cartDrawer.classList.contains('act_opened'));

    if (cartItem) cartItem.classList.toggle('is-action-active', cartOpen);
    if (cartButton) cartButton.setAttribute('aria-expanded', cartOpen ? 'true' : 'false');
  }

  function syncCartFromEvent(event) {
    window.requestAnimationFrame(function () {
      updateCartBadge(readCartCount(event && event.detail));
      syncActionStates();
    });
  }

  if (cartButton) {
    cartButton.addEventListener('click', function () {
      window.setTimeout(function () {
        if (!document.getElementById('js_cart_popup')) {
          var fallbackUrl = cartButton.dataset.fallbackUrl || '/cart';
          if (window.location.pathname !== fallbackUrl) window.location.assign(fallbackUrl);
          return;
        }
        syncActionStates();
      }, 0);
    });
  }

  ['rw:cart-drawer-rendered', 'drawer:Minicart', 'cart:updated'].forEach(function (eventName) {
    document.addEventListener(eventName, syncCartFromEvent);
    window.addEventListener(eventName, syncCartFromEvent);
  });
  document.body.addEventListener('ajax:addToCart', syncCartFromEvent);
  document.addEventListener('ajax:addToCart', syncCartFromEvent);

  var cartDrawer = document.getElementById('js_cart_popup');
  if (window.MutationObserver) {
    var stateObserver = new MutationObserver(syncActionStates);
    stateObserver.observe(html, { attributes: true, attributeFilter: ['class'] });
    if (cartDrawer) stateObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  function isTextEntry(element) {
    return Boolean(element && element.matches && element.matches('input, textarea, select, [contenteditable="true"]'));
  }

  document.addEventListener('focusin', function (event) {
    if (isTextEntry(event.target)) nav.classList.add('is-keyboard-open');
  });

  document.addEventListener('focusout', function () {
    window.setTimeout(function () {
      if (!isTextEntry(document.activeElement)) nav.classList.remove('is-keyboard-open');
    }, 0);
  });

  updateCartBadge(readCartCount());
  syncActionStates();
}());
